{
  "manager": {
    "actionsCreate": {
      "loadingConfiguration": "Loading action configuration...",
      "tryAgain": "Try again",
      "actionDetailsTitle": "Action Details",
      "actionNameLabel": "Action Name *",
      "actionNameDescription": "Give this automation a descriptive name.",
      "nameRequiredFeedback": "This field is required.",
      "namePlaceholder": "e.g., Send welcome email for summer camp signups",
      "automationFlowTitle": "Automation Flow",
      "automationFlowDescription": "Define when this action should trigger and what should happen.",
      "whenThisHappens": "When this happens...",
      "onlyWhen": "Only when...",
      "filterBy": "Filter by",
      "valueLabel": "Value",
      "conditionValuePlaceholder": "Enter value...",
      "thenDoThis": "Then do this...",
      "withTheseSettings": "With these settings...",
      "emailTemplateLabel": "Email Template",
      "emailTemplateFeedback": "Please select an email template.",
      "fixTheFollowing": "Please fix the following:",
      "selectTriggerEvent": "Select a trigger event",
      "selectAnAction": "Select an action",
      "specifyConditionValue": "Specify a condition value",
      "selectActionParameter": "Select an action parameter",
      "previewLabel": "Preview:",
      "saveAction": "Save Action",
      "previewActionFallback": "perform action",
      "previewIntroWithCondition": "When \"{event}\" occurs for the selected {parameter}",
      "previewIntro": "When \"{event}\" occurs",
      "previewAction": ", {action}",
      "previewUsing": " using \"{param}\"",
      "entityName": "Action",
      "saveNameError": "Action name error: {error}",
      "saveCheckInput": "Please check your input and try again.",
      "saveNotFound": "The selected event or action no longer exists. Please refresh and try again.",
      "savePermissionError": "You do not have permission to save this action.",
      "saveNetworkError": "Network error. Please check your connection and try again.",
      "saveGenericError": "Unable to save action. Please try again or contact support.",
      "loadDataError": "Unable to load action data. Please refresh the page or contact support.",
      "loadConfigError": "Failed to load action configuration.",
      "editTitle": "Edit Action",
      "createTitle": "Create Action"
    },
    "actionsIndex": {
      "title": "Actions"
    },
    "inputActionModelSearch": {
      "selectedLabel": "Selected {name}:",
      "sessionExpired": "Your session has expired. Please refresh the page.",
      "noPermission": "You do not have permission to search this resource.",
      "searchError": "Unable to search {name}.",
      "idFallback": "ID: {id}",
      "idUnableToLoad": "ID: {id} (unable to load)",
      "deletedError": "The selected {name} may have been deleted.",
      "loadError": "Unable to load {name} details.",
      "searchPlaceholder": "Search {name}..."
    }
  }
}
